import { render, staticRenderFns } from "./confirmation-completion.vue?vue&type=template&id=55f8e51c&scoped=true"
import script from "./confirmation-completion.vue?vue&type=script&lang=js"
export * from "./confirmation-completion.vue?vue&type=script&lang=js"
import style0 from "./confirmation-completion.vue?vue&type=style&index=0&id=55f8e51c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f8e51c",
  null
  
)

export default component.exports